import React from 'react';
import CustomerContactInfoComp from './CustomerContactInfoComp';

const CustomerContactInfoStreet = props =>
  (
<CustomerContactInfoComp
  {...props}
  autoComplete="address-line1"
  errorMessages={{
    'field_is_required': 'The address field is required',
    'field_is_invalid': 'Your address is invalid',
  }}
  label="Address"
  name="street"
/>
  );

export default CustomerContactInfoStreet;
